import { render, staticRenderFns } from "./OTPCredit.vue?vue&type=template&id=5acc04f6"
import script from "./OTPCredit.vue?vue&type=script&lang=js"
export * from "./OTPCredit.vue?vue&type=script&lang=js"
import style0 from "./OTPCredit.vue?vue&type=style&index=0&id=5acc04f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports